export enum FiatAccountType {
  ach = 'ACH',
  swift = 'SWIFT',
  wire = 'WIRE',
  pix = 'PIX',
  cop = 'COP',
  spei = 'SPEI',
  cvu = 'CVU',
  unset = '',
}
